import {
  Box,
  BoxProps,
  Center,
  chakra,
  VisuallyHidden,
} from "@chakra-ui/react";

const Bar = chakra("span", {
  baseStyle: {
    display: "block",
    pos: "absolute",
    w: "1.25rem",
    h: "0.125rem",
    rounded: "full",
    bg: "currentcolor",
    mx: "auto",
    insetStart: "0.125rem",
    transition: "all 0.12s",
  },
});

const ToggleIcon = (props: BoxProps & { active: boolean }) => {
  const { active, ...rest } = props;
  return (
    <Box
      className="group"
      data-active={active ? "" : undefined}
      as="span"
      display="block"
      w="1.5rem"
      h="1.5rem"
      pos="relative"
      aria-hidden
      pointerEvents="none"
      {...rest}
    >
      <Bar
        top="0.4375rem"
        _groupActive={{
          top: "0.6875rem",
          transform: "rotate(45deg)",
        }}
      />
      <Bar
        bottom="0.4375rem"
        _groupActive={{
          bottom: "0.6875rem",
          transform: "rotate(-45deg)",
        }}
      />
    </Box>
  );
};

interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export const HamburgerButton = ({ isOpen, onClick }: HamburgerButtonProps) => {
  return (
    <Center
      as="button"
      color={"white"}
      _active={{
        color: "blue.600",
      }}
      onClick={onClick}
    >
      <ToggleIcon active={isOpen} />
      <VisuallyHidden>Toggle Menu</VisuallyHidden>
    </Center>
  );
};
